import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { PageContainer } from "../../components/PageContainer";
import { AppVersionCard } from "./AppVersionCard";
import { DateRangeNav } from "./DateRangeNav";
import { useDateRange } from "./useDateRange";

const AppVersionPage = () => {
  const dateRange = useDateRange();
  const { startDate, endDate } = dateRange;

  return (
    <PageContainer title="Active Users by App Version">
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="h6">Active users by App version</Typography>
          <DateRangeNav dateRange={dateRange} />
        </Box>
        <AppVersionCard startDate={startDate} endDate={endDate} />
      </Paper>
    </PageContainer>
  );
};

export default AppVersionPage;
